package world.phantasmal.web.viewer.models

class AnimationModel(val name: String, val filePath: String)
